
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {DateTime} from "luxon";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {bincardStore} from "@/store/bincardStore";
import {BincardService} from "@/services/BincardService";
import {MaterialService} from "@/services/MaterialService";
import {materialStore} from "@/store/materialStore";


@Component({
  name: "ShowBincard",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  @Prop() materialEdit!: any
  private bincardStore = bincardStore();
  private bincardService = BincardService.getInstance();
  private materialStore = materialStore();
  private materialService = MaterialService.getInstance();

  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  material = {
    id: this.$route.params.materialEdit.id,
    codigo: this.$route.params.materialEdit.codigo,
    descripcion: this.$route.params.materialEdit.descripcion,
    partida: this.$route.params.materialEdit.partida,
    unidad: this.$route.params.materialEdit.unidad,
    fecha_creacion: this.$route.params.materialEdit.fecha_creacion,
    numero: this.$route.params.materialEdit.numero,
    partida_id: this.$route.params.materialEdit.partida_gasto_id,
    grupo_id: this.$route.params.materialEdit.grupo_material_id
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted() {
    this.showMaterialBincard();
  }

  get grupoMaterial(): any {
    return this.materialStore.grupoMaterial;
  }

  getGrupoMaterial() {
    this.materialService.getGrupoMaterial();
  }

  get saldoInicial(): any[] {
    return this.bincardStore.saldoInicial;
  }
  get showBincard(): any[] {
    return this.bincardStore.bincard;
  }

  get sumIngresos(): any[] {
    return this.bincardStore.sumIngresos;
  }
  get sumSalidas(): any[] {
    return this.bincardStore.sumSalidas;
  }

  get loading(): boolean {
    return this.bincardStore.loading;
  }

  showMaterialBincard(){
    const data = {
      materialId: this.material.id,
    }
    this.bincardService.showBindCardPeps(data);
  }




}
